import { useEffect, useState } from 'react';
import { getTheme, useThemeMode } from '../theme';
import { api } from '../api.ts';
import type { HunterApproval } from '../api.ts';
import { HunterApprovalStatus } from '../panels/HunterApprovalPanels';

/** Betalar ett signerat medlemsavtal med kort via Stripe Checkout (till Qvenari). Kräver godkänd jägare. */
export function ContractPayButton({ contractId, amount }: { contractId: string; amount: number }) {
  const { mode } = useThemeMode();
  const T = getTheme(mode);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const [approval, setApproval] = useState<HunterApproval | null>(null);

  useEffect(() => { api.hunterApproval().then(setApproval).catch(() => setApproval({ status: 'none', note: null, hasExam: false })); }, []);

  async function pay() {
    setBusy(true); setErr('');
    try {
      const { sessionUrl } = await api.startContractCheckout(contractId);
      window.location.href = sessionUrl;
    } catch (e: any) {
      setErr(e.message || 'Kunde inte starta betalningen');
      setBusy(false);
    }
  }

  if (!approval) return <div style={{ color: T.textSub, fontSize: 13, textAlign: 'center', padding: 20 }}>Kontrollerar behörighet…</div>;

  if (approval.status !== 'approved') {
    return (
      <div style={{ padding: 20 }}>
        <div style={{ fontSize: 15, fontWeight: 700, color: T.text, marginBottom: 6 }}>Godkänd jägare krävs</div>
        <div style={{ fontSize: 13, color: T.textSub, lineHeight: 1.6 }}>
          För att betala medlemskapet måste du vara godkänd jägare. Vi granskar ditt jägarexamensbevis (Profil → Jägarexamenbevis) innan du kan betala.
        </div>
        <HunterApprovalStatus hasLocalExam={approval.hasExam} />
      </div>
    );
  }

  return (
    <div style={{ textAlign: 'center', padding: 20 }}>
      <div style={{ fontSize: 32, fontWeight: 800, color: '#4CAF50', marginBottom: 4 }}>{amount.toLocaleString('sv-SE')} kr</div>
      <div style={{ fontSize: 13, color: T.textSub, marginBottom: 16 }}>Betalas till Qvenari med kort. Medlemskapet aktiveras direkt när betalningen gått igenom.</div>
      <button onClick={pay} disabled={busy || amount <= 0} style={{ width: '100%', background: T.amber, color: '#000', border: 'none', borderRadius: 8, padding: '14px 24px', fontSize: 16, fontWeight: 800, cursor: 'pointer', opacity: busy || amount <= 0 ? 0.6 : 1 }}>
        {busy ? 'Skickar till Stripe…' : 'Betala med kort'}
      </button>
      {err && <div style={{ color: '#f88', fontSize: 13, marginTop: 12 }}>{err}</div>}
      <div style={{ fontSize: 11, color: T.textMuted, marginTop: 10 }}>Du skickas till Stripe för säker betalning</div>
    </div>
  );
}
